<div class="position-container {{ state }}" [class.defines-height]="definesHeight" [style.top]="topOffset">
    <div #pageContainer class="page-container">
        <ng-content></ng-content>
    </div>
</div>